import React from 'react'
import BmiCalculator from '../assets/bmi-calculator.png';
import NumberGuesser from '../assets/number-guesser.png'
import NetflixClone from '../assets/netflixx-clone.png';
import LoanCalculator from '../assets/loan-calculatorr.png'
import StickyNote from '../assets/sticky-note.png';

const Project = () => {
  return (
    <div name='projects' className='bg-[#0a192f] w-full md:h-screen text-gray-300'>
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-blue-600'>Projects</p>
          <p className='py-6 text-gray-300'>Check out some of the projects I have worked on</p>
        </div>

        {/* Container */}
        <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>

          {/* Grid Item */}
          <div style={{ backgroundImage: `url(${NetflixClone})`}} 
          className='shadow-lg shadow-[#040c16] group container full rounded-md flex justify-center items-center mx-auto content-div'>

            {/* Hover effect */}
            <div className='opacity-0 group-hover:opacity-100'>
              <span className='text-2xl font-bold text-white tracking-wider'>
                Netflix Clone
              </span>
              <div className='pt-8 text-center'>
                <a href='https://netflixx-clonne-app.netlify.app' rel='noreferrer' target='_blank'>
                  <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>View Demo</button>
                </a>
              </div>
            </div>
          </div>

        {/* Grid Item */}
        <div style={{ backgroundImage: `url(${StickyNote})`}} 
          className='shadow-lg shadow-[#040c16] group container full rounded-md flex justify-center items-center mx-auto content-div'>

            {/* Hover effect */}
            <div className='opacity-0 group-hover:opacity-100'>
              <span className='text-2xl font-bold text-white tracking-wider'>
                Sticky Note
              </span>
              <div className='pt-8 text-center'>
                <a href='https://sticky-note1.netlify.app' rel='noreferrer' target='_blank'>
                  <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>View Demo</button>
                </a>
              </div>
            </div>
          </div>


          {/* Grid Item */}
          <div style={{ backgroundImage: `url(${BmiCalculator})`}} 
          className='shadow-lg shadow-[#040c16] group container full rounded-md flex justify-center items-center mx-auto content-div'>

            {/* Hover effect */}
            <div className='opacity-0 group-hover:opacity-100'>
              <span className='text-2xl font-bold text-white tracking-wider'>
                BMI Calculator
              </span>
              <div className='pt-8 text-center'>
                <a href='https://onlyy-bmi-calculator.netlify.app/' rel='noreferrer' target='_blank'>
                  <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>View Demo</button>
                </a>
              </div>
            </div>
          </div>

             {/* Grid Item */}
          <div style={{ backgroundImage: `url(${LoanCalculator})`}} 
          className='shadow-lg shadow-[#040c16] group container full rounded-md flex justify-center items-center mx-auto content-div'>

            {/* Hover effect */}
            <div className='opacity-0 group-hover:opacity-100'>
              <span className='text-2xl font-bold text-white tracking-wider'>
                Loan Calculator
              </span>
              <div className='pt-8 text-center'>
                <a href='https://62dd47e451a2e05b3c1b7f71--benevolent-platypus-3f99f6.netlify.app/' rel='noreferrer' target='_blank'>
                  <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>View Demo</button>
                </a>
              </div>
            </div>
          </div>

            {/* Grid Item */}
            <div style={{ backgroundImage: `url(${NumberGuesser})`}} 
          className='shadow-lg shadow-[#040c16] group container full rounded-md flex justify-center items-center mx-auto content-div'>

            {/* Hover effect */}
            <div className='opacity-0 group-hover:opacity-100'>
              <span className='text-2xl font-bold text-white tracking-wider'>
                Number Guesser
              </span>
              <div className='pt-8 text-center'>
                <a href='https://62c46d667e17d33787a254a8--frolicking-melba-6b915a.netlify.app/' rel='noreferrer' target='_blank'>
                  <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>View Demo</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Project;
